import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeResourcePipe } from '../../../../shared/pipes/safe-resource.pipe';
import { ToHttpsPipe } from '../../../../shared/pipes/to-https.pipe';

@Component({
    selector: 'app-iframe-video-player',
    standalone: true,
    imports: [CommonModule, SafeResourcePipe, ToHttpsPipe],
    templateUrl: './iframe-video-player.component.html',
    styleUrl: './iframe-video-player.component.scss',
})
export class IframeVideoPlayerComponent {
    @Input() public url: string | null | undefined;
}
